export const compareStringArray = (first: Array<string> = [], second: Array<string> = []): boolean =>
  first.length === second.length && first.every((e) => second.includes(e))

export const getRandomAlphaNumString = (length: number): string => {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export const onGenerateKey = (length: number) => {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let result = ''
  for (let i = length; i > 0; --i) {
    result += chars[Math.floor(Math.random() * chars.length)]
  }
  return result
}

export const toCapitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function isEmptyString(str: string): boolean {
  return !str || str.length === 0
}
